var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state, query } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
const DEFAULT_PALETTE = [
    '#1b96ff',
    '#0078d4',
    '#2aa66e',
    '#6cc04a',
    '#ffc85b',
    '#f08f45',
    '#e84c3d',
    '#d63384',
    '#7b3ff2',
    '#607d8b',
    '#424242',
    '#000000',
];
let ColorPicker = class ColorPicker extends LitElement {
    constructor() {
        super(...arguments);
        this.color = '#1b96ff';
        this.palette = DEFAULT_PALETTE;
        this.open = false;
        this.customColor = '';
    }
    handleSwatchClick(color) {
        this.emitChange(color);
    }
    handleCustomInput(e) {
        const input = e.target;
        this.customColor = input.value;
    }
    handleCustomApply() {
        const value = (this.customColor || this.colorInput?.value || '').trim();
        if (value) {
            this.emitChange(value);
        }
    }
    emitChange(color) {
        this.color = color;
        this.dispatchEvent(new CustomEvent('color-change', {
            detail: { color },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
      <div class="swatches">
        ${this.palette.map((c) => html `
            <button
              class="swatch"
              type="button"
              style=${`background: ${c}`}
              ?selected=${c.toLowerCase() === this.color?.toLowerCase()}
              title=${c}
              @click=${() => this.handleSwatchClick(c)}
            ></button>
          `)}
      </div>
      <div class="divider"></div>
      <div class="custom">
        <input
          type="color"
          .value=${this.customColor || this.color || '#1b96ff'}
          @input=${this.handleCustomInput}
        />
        <button type="button" @click=${this.handleCustomApply}>
          ${msg('Apply custom', { id: 'form.color.applyCustom', desc: 'Apply custom color button' })}
        </button>
      </div>
    `;
    }
};
ColorPicker.styles = css `
    :host {
      display: none;
      position: absolute;
      z-index: 30;
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      padding: 8px;
      font-family: inherit;
      width: 172px;
    }

    :host([open]) {
      display: block;
    }

    .swatches {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 4px;
    }

    .swatch {
      width: 22px;
      height: 22px;
      border-radius: 4px;
      cursor: pointer;
      border: 2px solid transparent;
      transition:
        transform 0.1s,
        border-color 0.15s;
    }

    .swatch:hover {
      transform: scale(1.12);
    }

    .swatch[selected] {
      border-color: #0078d4;
    }

    .divider {
      height: 1px;
      background: #eee;
      margin: 6px 0;
    }

    .custom {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 11px;
      color: #666;
    }

    .custom input[type='color'] {
      width: 24px;
      height: 24px;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 0;
      cursor: pointer;
      background: transparent;
    }

    .custom button {
      flex: 1;
      padding: 4px 8px;
      font-size: 11px;
      color: #333;
      background: #f5f7fa;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: pointer;
      font-family: inherit;
    }

    .custom button:hover {
      background: #e8ecef;
    }
  `;
__decorate([
    property({ type: String })
], ColorPicker.prototype, "color", void 0);
__decorate([
    property({ type: Array })
], ColorPicker.prototype, "palette", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ColorPicker.prototype, "open", void 0);
__decorate([
    state()
], ColorPicker.prototype, "customColor", void 0);
__decorate([
    query('input[type="color"]')
], ColorPicker.prototype, "colorInput", void 0);
ColorPicker = __decorate([
    localized(),
    customElement('color-picker')
], ColorPicker);
export { ColorPicker };
//# sourceMappingURL=ColorPicker.js.map